module.exports = __webpack_public_path__ + "ccf15bf3f2e34834fc1ec1eb5dc68e6c.png";